// extracted by mini-css-extract-plugin
export default {"rating":"EH-z","numberOfStars":"FH-z","count":"GH-z","barGraphSpacing":"HH-z","barGraph":"IH-z"};